import React from 'react';
import { useMemo } from 'react';

const iconList = [
  {
    image: {
      src: '/_next/static/media/1.7444e9b9.svg',
      href: "https://s5.ssl.qhres2.com/static/1d2d33b41c5d1c86.svg",
      height: 24,
      width: 24,
      blurWidth: 0,
      blurHeight: 0,
    },
    name: '智能体',
  },
  {
    image: {
      src: '/_next/static/media/2.542cdcf5.svg',
      href: "https://s3.ssl.qhres2.com/static/2c2b5a54f1d3731b.svg",
      height: 24,
      width: 24,
      blurWidth: 0,
      blurHeight: 0,
    },
    name: '条件',
  },
  {
    image: {
      src: '/_next/static/media/3.b37eda1b.svg',
      href: "https://s1.ssl.qhres2.com/static/91cf7f78b1c57de7.svg",
      height: 24,
      width: 24,
      blurWidth: 0,
      blurHeight: 0,
    },
    name: '迭代',
  },
  {
    image: {
      src: '/_next/static/media/4.6d34130c.svg',
      href: "https://s0.ssl.qhres2.com/static/cbf4d634fed6bb64.svg",
      height: 24,
      width: 24,
      blurWidth: 0,
      blurHeight: 0,
    },
    name: '智能',
  },
  {
    image: {
      src: '/_next/static/media/5.fb562703.svg',
      href: "https://s4.ssl.qhres2.com/static/d2be61f647cbf0d9.svg",
      height: 24,
      width: 24,
      blurWidth: 0,
      blurHeight: 0,
    },
    name: '助手',
  },
  {
    image: {
      src: '/_next/static/media/6.cff06444.svg',
      href: "https://s0.ssl.qhres2.com/static/e8027de0a2a4c3a6.svg",
      height: 24,
      width: 24,
      blurWidth: 0,
      blurHeight: 0,
    },
    name: '魔法棒',
  },
  {
    image: {
      src: '/_next/static/media/7.4f6636de.svg',
      href: "https://s1.ssl.qhres2.com/static/a5d9d660c9e4673e.svg",
      height: 24,
      width: 24,
      blurWidth: 0,
      blurHeight: 0,
    },
    name: '连接',
  },
  {
    image: {
      src: '/_next/static/media/8.44fa12a5.svg',
      href: "https://s3.ssl.qhres2.com/static/32854fa382f221f9.svg",
      height: 24,
      width: 24,
      blurWidth: 0,
      blurHeight: 0,
    },
    name: '机器人',
  },
  {
    image: {
      src: '/_next/static/media/9.6940d718.svg',
      href: "https://s4.ssl.qhres2.com/static/b16a2461616b6ba0.svg",
      height: 24,
      width: 24,
      blurWidth: 0,
      blurHeight: 0,
    },
    name: '想法',
  },
  {
    image: {
      src: '/_next/static/media/10.6164d8f1.svg',
      href: "https://s2.ssl.qhres2.com/static/9bc067c25e8b8e1d.svg",
      height: 24,
      width: 24,
      blurWidth: 0,
      blurHeight: 0,
    },
    name: '语音',
  },
  {
    image: {
      src: '/_next/static/media/11.0693bc66.svg',
      href: "https://s1.ssl.qhres2.com/static/76bd4c01b586a27a.svg",
      height: 24,
      width: 24,
      blurWidth: 0,
      blurHeight: 0,
    },
    name: '图片',
  },
  {
    image: {
      src: '/_next/static/media/12.23a11251.svg',
      href: "https://s2.ssl.qhres2.com/static/4a12e53c770ad6fb.svg",
      height: 24,
      width: 24,
      blurWidth: 0,
      blurHeight: 0,
    },
    name: '组件',
  },
  {
    image: {
      src: '/_next/static/media/13.28e2606a.svg',
      href: "https://s4.ssl.qhres2.com/static/a5885678f2c22275.svg",
      height: 24,
      width: 24,
      blurWidth: 0,
      blurHeight: 0,
    },
    name: '循环',
  },
  {
    image: {
      src: '/_next/static/media/14.da4121a8.svg',
      href: "https://s3.ssl.qhres2.com/static/956187551a55b9e7.svg",
      height: 24,
      width: 24,
      blurWidth: 0,
      blurHeight: 0,
    },
    name: '盒子',
  },
  {
    image: {
      src: '/_next/static/media/15.dbb13c20.svg',
      href: "https://s3.ssl.qhres2.com/static/67d7e8be222137b0.svg",
      height: 24,
      width: 24,
      blurWidth: 0,
      blurHeight: 0,
    },
    name: '智能体',
  },
  {
    image: {
      src: '/_next/static/media/16.a5760b5a.svg',
      href: "https://s1.ssl.qhres2.com/static/f193a17d6db8a0b1.svg",
      height: 24,
      width: 24,
      blurWidth: 0,
      blurHeight: 0,
    },
    name: '圆球',
  },
  {
    image: {
      src: '/_next/static/media/17.f5236a5b.svg',
      href: "https://s5.ssl.qhres2.com/static/ba5ff917a9920e30.svg",
      height: 24,
      width: 24,
      blurWidth: 0,
      blurHeight: 0,
    },
    name: '正负线',
  },
  {
    image: {
      src: '/_next/static/media/18.8747ea8d.svg',
      href: "https://s3.ssl.qhres2.com/static/bb0522f49fa02134.svg",
      height: 24,
      width: 24,
      blurWidth: 0,
      blurHeight: 0,
    },
    name: '建筑',
  },
  {
    image: {
      src: '/_next/static/media/19.75c5e370.svg',
      href: "https://s5.ssl.qhres2.com/static/feb74eea94f40da2.svg",
      height: 24,
      width: 24,
      blurWidth: 0,
      blurHeight: 0,
    },
    name: '视频',
  },
  {
    image: {
      src: '/_next/static/media/20.ba65e215.svg',
      href: "https://s0.ssl.qhres2.com/static/85629121c512a2a0.svg",
      height: 24,
      width: 24,
      blurWidth: 0,
      blurHeight: 0,
    },
    name: '代码',
  },
  {
    image: {
      src: '/_next/static/media/21.0ee522ac.svg',
      href: "https://s2.ssl.qhres2.com/static/dbb67222e344d2ab.svg",
      height: 24,
      width: 24,
      blurWidth: 0,
      blurHeight: 0,
    },
    name: '智能体',
  },
  {
    image: {
      src: '/_next/static/media/22.6765e635.svg',
      href: "https://s0.ssl.qhres2.com/static/b0049ac2bcc3c216.svg",
      height: 25,
      width: 24,
      blurWidth: 0,
      blurHeight: 0,
    },
    name: '数据',
  },
  {
    image: {
      src: '/_next/static/media/23.1d4ea26e.svg',
      href: "https://s0.ssl.qhres2.com/static/5c8ed3add8ff9354.svg",
      height: 24,
      width: 24,
      blurWidth: 0,
      blurHeight: 0,
    },
    name: '设备',
  },
  {
    image: {
      src: '/_next/static/media/24.09ec5416.svg',
      href: "https://s4.ssl.qhres2.com/static/5ed25de651b177b2.svg",
      height: 24,
      width: 24,
      blurWidth: 0,
      blurHeight: 0,
    },
    name: '提速',
  },
  {
    image: {
      src: '/_next/static/media/25.f89b9db4.svg',
      href: "https://s5.ssl.qhres2.com/static/c9a706174b664ba0.svg",
      height: 24,
      width: 24,
      blurWidth: 0,
      blurHeight: 0,
    },
    name: '链接',
  },
  {
    image: {
      src: '/_next/static/media/26.1d740080.svg',
      href: "https://s2.ssl.qhres2.com/static/bb22ece3a0b9cd80.svg",
      height: 24,
      width: 24,
      blurWidth: 0,
      blurHeight: 0,
    },
    name: '安全',
  },
  {
    image: {
      src: '/_next/static/media/27.d2a507ac.svg',
      href: "https://s3.ssl.qhres2.com/static/f4359b92846a0cb1.svg",
      height: 24,
      width: 24,
      blurWidth: 0,
      blurHeight: 0,
    },
    name: '日期',
  },
  {
    image: {
      src: '/_next/static/media/28.7eeff9be.svg',
      href: "https://s4.ssl.qhres2.com/static/f910229781eb17fe.svg",
      height: 24,
      width: 24,
      blurWidth: 0,
      blurHeight: 0,
    },
    name: '向标',
  },
];

const FlowIcon = props => {
  const { className = '', event } = props;

  const {
    agent_icon,
    icon_index: agent_icon_index,
    color: agent_color,
    color_index: agent_color_index,
  } = event;

  const containerStyle = useMemo(() => {
    const style = {
      background: '#f0f0f0',
    };
    if (agent_color) {
      style.background = agent_color;
    }
    // TODO 需要列表
    else if (agent_color_index != undefined) {
    }
    return style;
  }, [agent_color, agent_color_index]);

  const imgSrc = useMemo(() => {
    // debug
    // return "https://s5.ssl.qhres2.com/static/1d2d33b41c5d1c86.svg";

    if (agent_icon) {
      return agent_icon;
    }
    else if (agent_icon_index != undefined) {
      const item = iconList[agent_icon_index];
      if (item) {
        return item.image.href;
      }
    }
    return 'https://s5.ssl.qhres2.com/static/1d2d33b41c5d1c86.svg';
  }, [agent_icon, agent_icon_index]);

  return (
    <div
      className={`flex items-center justify-center ${className}`}
      style={containerStyle}
    >
      <img className="w-7/10 h-7/10" src={imgSrc} />
    </div>
  );
};
export default FlowIcon;
